module.exports = __webpack_public_path__ + "img/empregado.6b754e96.png";